import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { useAuth } from "../context/AuthContext";
import { Check, Loader2, Crown } from "lucide-react";
import { toast } from "sonner";

const PREMIUM_FEATURES = [
  "Daily Content Studio — generate shareable advice cards",
  "Download branded PNG cards for social media",
  "Your full question & answer history, saved",
  "Priority access to new Shabba Robo features",
];

export const UpgradeDialog = () => {
  const { upgradeOpen, setUpgradeOpen, user, goToCheckout } = useAuth();
  const [loading, setLoading] = React.useState(false);

  const subscribe = async () => {
    setLoading(true);
    try {
      await goToCheckout();
    } catch (err) {
      toast.error("Could not start checkout. Please try again.");
      setLoading(false);
    }
  };

  const onTrial = user?.status === "trial";

  return (
    <Dialog open={upgradeOpen} onOpenChange={setUpgradeOpen}>
      <DialogContent className="bg-ink text-sand-light border-ink rounded-3xl sm:max-w-md" data-testid="upgrade-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl text-ochre flex items-center gap-2">
            <Crown size={22} /> Shabba Robo Premium
          </DialogTitle>
        </DialogHeader>

        <div className="flex items-end gap-2">
          <span className="font-display font-black text-4xl">₦2,500</span>
          <span className="text-sand-light/60 mb-1">/ month</span>
        </div>

        {onTrial && (
          <p className="text-sm text-ochre bg-ochre/10 rounded-xl px-4 py-2">
            You're on a free trial with {user?.trial_days_left} day{user?.trial_days_left === 1 ? "" : "s"} left. Subscribe anytime to keep premium after it ends.
          </p>
        )}

        <ul className="space-y-3 mt-2">
          {PREMIUM_FEATURES.map((f) => (
            <li key={f} className="flex items-start gap-3 text-sm text-sand-light/85">
              <Check size={18} className="text-leaf shrink-0 mt-0.5" />
              {f}
            </li>
          ))}
        </ul>

        <button
          onClick={subscribe}
          disabled={loading}
          className="mt-3 w-full rounded-full bg-clay text-white font-bold py-3.5 hover:bg-clay-hover transition-transform hover:-translate-y-0.5 disabled:opacity-60 flex items-center justify-center gap-2"
          data-testid="upgrade-subscribe-btn"
        >
          {loading ? <Loader2 size={18} className="animate-spin" /> : <Crown size={18} />}
          Subscribe with Flutterwave
        </button>
        <p className="text-center text-xs text-sand-light/40">
          Secure payment via Flutterwave · card, bank transfer &amp; USSD
        </p>
      </DialogContent>
    </Dialog>
  );
};
